export default __webpack_public_path__ + "static/media/user-icon.525b3d29.svg";